const documentReviewReviewers = [
    {
        'uuid': '1',
        'projectManager': 'Howard Wang',
        'reviewer': 'May Shih',
        'review': [
            {'appType': 'initial', 'reviewTiming': 'firstAndLast'},
            {'appType': 'change', 'reviewTiming': 'everyTime'},
            {'appType': 'followUp', 'reviewTiming': 'firstAndLast'},
            {'appType': 'renewal', 'reviewTiming': 'firstAndLast'},
        ],
    },
    {
        'uuid': '2',
        'projectManager': 'Frank Lin',
        'reviewer': 'May Shih',
        'review': [
            {'appType': 'initial', 'reviewTiming': 'firstAndLast'},
            {'appType': 'change', 'reviewTiming': 'everyTime'},
            {'appType': 'followUp', 'reviewTiming': 'firstAndLast'},
            {'appType': 'renewal', 'reviewTiming': 'firstAndLast'},
        ],
    },
    {
        'uuid': '3',
        'projectManager': 'Sam Lee',
        'reviewer': 'Winnie Huang',
        'review': [
            {'appType': 'initial', 'reviewTiming': 'firstAndLast'},
            {'appType': 'change', 'reviewTiming': 'everyTime'},
            {'appType': 'followUp', 'reviewTiming': 'firstAndLast'},
            {'appType': 'renewal', 'reviewTiming': 'firstAndLast'},
        ],
    },
]

export default documentReviewReviewers;